import React from 'react';
import LandingPage from './LandingPage';
import './font.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
